import { render } from "./UserRanking.vue?vue&type=template&id=b545b8ae&scoped=true"
import script from "./UserRanking.vue?vue&type=script&lang=js"
export * from "./UserRanking.vue?vue&type=script&lang=js"

import "./UserRanking.vue?vue&type=style&index=0&id=b545b8ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b545b8ae"]])

export default __exports__